import React from "react";
import { Outlet } from "react-router-dom";
import MobileBottomNav from "../components/MobileBottomNav";

/**
 * No site chrome: admin, business and venue portals, the scan/redeem flows,
 * minigames, the pitch deck and pages that paint their own header.
 *
 * `bottomNav` keeps the one pre-layout quirk the chrome golden records:
 * /email-preferences hid the site chrome but not the patron bottom nav.
 */
export default function PortalLayout({ bottomNav = false }) {
  return (
    <>
      <Outlet />
      {bottomNav && <MobileBottomNav />}
    </>
  );
}
